/**
 * Owner: Masa Bayu
 * File: routing.ts
 * Date:Time: 2026-10-29 10:12
 * Description: QXRead shell routing — satu pintu Studio (`/author/studio`).
 */
/** PKT SPSU live verify canvases · /p01…/p99 · optional PoC suffix · e.g. /p19-dropcap. */
export const QXREAD_PKT_LADDER_PATH = /^\/p\d{2}(?:-[a-z0-9]+)?$/;
export const QXREAD_SHELL_ROUTES = [
    '/',
    '/all-books',
    '/bestsellers',
    '/browse',
    '/discover',
    '/search',
    '/categories',
    '/topics',
    '/collections',
    '/publication/:publicationId',
    '/cart',
    '/checkout',
    '/orders',
    '/library',
    '/my-books',
    '/qxeditor',
    '/authors',
    '/author',
    '/author/dashboard',
    '/author/profile',
    '/author/publications',
    '/author/storefront',
    '/author/sales',
    '/author/earnings',
    '/author/analytics',
    '/author/studio',
    '/author/settings',
    '/become-an-author',
    '/admin',
    '/admin/executive',
    '/admin/users',
    '/admin/publications',
    '/admin/commerce',
    '/admin/moderation',
    '/admin/security',
    '/admin/audit',
    '/admin/system',
    '/account',
    '/account/editor',
    '/login',
    '/offline',
    '/packages',
    '/sync',
    '/media',
    '/flip',
    '/motion',
    '/adam',
    '/read/:publicationId',
    '/circle',
    '/live',
    '/p02',
    '/p03',
    '/p04',
];
/**
 * R-01 soft redirects — compatibility aliases only.
 * Canonical destinations remain Author publications · Account/Profile shell.
 */
export const QXREAD_SHELL_SOFT_REDIRECTS = Object.freeze({
    '/sell': '/author/publications',
    '/profile': '/account',
    '/qxeditor': '/author/studio',
    '/account/editor': '/author/studio',
});
/** Tracks closed — routes reserved until their Gates (T9). */
export const QXREAD_CLOSED_TRACK_ROUTE_PREFIXES = ['/reader-integration'];
/** Map compatibility aliases to canonical open-shell paths. */
export function canonicalizeQxreadShellPath(path) {
    const trimmed = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
    if (trimmed === '/qxeditor' || trimmed.startsWith('/qxeditor/')) {
        return '/author/studio';
    }
    if (trimmed === '/account/editor' || trimmed.startsWith('/account/editor/')) {
        return '/author/studio';
    }
    const aliased = QXREAD_SHELL_SOFT_REDIRECTS[trimmed];
    return aliased ?? path;
}
function isCanonicalQxreadShellRoute(path) {
    if (typeof path !== 'string' || !path.startsWith('/')) {
        return false;
    }
    for (const closed of QXREAD_CLOSED_TRACK_ROUTE_PREFIXES) {
        if (path === closed || path.startsWith(`${closed}/`)) {
            return false;
        }
    }
    if (QXREAD_PKT_LADDER_PATH.test(path)) {
        return true;
    }
    if (QXREAD_SHELL_ROUTES.includes(path)) {
        return true;
    }
    return (/^\/publication\/[^/]+$/.test(path) ||
        /^\/categories\/[^/]+$/.test(path) ||
        /^\/topics\/[^/]+$/.test(path) ||
        /^\/collections\/[^/]+$/.test(path) ||
        /^\/orders\/[^/]+$/.test(path) ||
        /^\/author\/[^/]+$/.test(path) ||
        /^\/admin\/[^/]+$/.test(path) ||
        /^\/library\/open\/[^/]+$/.test(path) ||
        /^\/library\/resume\/[^/]+$/.test(path) ||
        /^\/read\/[^/]+$/.test(path) ||
        /^\/account\/[^/]+$/.test(path) ||
        path === '/circle' ||
        path.startsWith('/circle/') ||
        path === '/live' ||
        path.startsWith('/live/'));
}
export function isQxreadShellRoute(path) {
    return isCanonicalQxreadShellRoute(canonicalizeQxreadShellPath(path));
}
export function assertShellRouteOpen(path) {
    if (!isQxreadShellRoute(path)) {
        throw new Error(`QXRead shell route closed or invalid: ${path}`);
    }
}
//# sourceMappingURL=routing.js.map